function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_274",
  "data-name": "Rectangle 274",
  width: 28,
  height: 25.087,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "img",
  transform: "translate(-20 -164)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_155",
  "data-name": "Rectangle 155",
  width: 60,
  height: 60,
  rx: 30,
  transform: "translate(20 164)",
  fill: "#e7e7ea"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_127",
  "data-name": "Group 127",
  transform: "translate(36 181.457)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_126",
  "data-name": "Group 126",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_125",
  "data-name": "Group 125",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_124",
  "data-name": "Group 124",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_123",
  "data-name": "Group 123",
  transform: "translate(0 0)",
  opacity: 0.43
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_122",
  "data-name": "Group 122",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_121",
  "data-name": "Group 121",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2816",
  "data-name": "Path 2816",
  d: "M23.39,22.759a7.562,7.562,0,0,0,3.273-4.988,7.472,7.472,0,0,0,.094-1.177c0-5.323-5.637-9.639-12.59-9.639S1.575,11.27,1.575,16.594a7.417,7.417,0,0,0,3.89,6.543,17.721,17.721,0,0,0,9.045,2.032c4.554,0,6.951-1.089,8.88-2.41",
  transform: "translate(-0.248 -1.093)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2817",
  "data-name": "Path 2817",
  d: "M13.977,6.766c6.953,0,12.59,4.315,12.59,9.639a7.472,7.472,0,0,1-.094,1.177A7.562,7.562,0,0,1,23.2,22.571c-1.929,1.321-4.326,2.41-8.88,2.41a17.721,17.721,0,0,1-9.045-2.032,7.417,7.417,0,0,1-3.89-6.543c0-5.323,5.637-9.639,12.59-9.639m0-1.011c-7.5,0-13.6,4.777-13.6,10.65a8.558,8.558,0,0,0,.6,3.151,8.66,8.66,0,0,0,3.794,4.27,19.1,19.1,0,0,0,9.547,2.165c5,0,7.583-1.308,9.452-2.587a8.6,8.6,0,0,0,3.7-5.663,8.458,8.458,0,0,0,.106-1.337c0-5.873-6.1-10.65-13.6-10.65",
  transform: "translate(-0.059 -0.904)",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2818",
  "data-name": "Path 2818",
  d: "M15.2,13.919c4.053.3,7.388.438,9.639.5a12.443,12.443,0,0,1,1.6.458,9.1,9.1,0,0,0-2.657-3.924c-1.231,0-2.178.087-2.178.087A71.636,71.636,0,0,1,7,11.079s-1.051-.094-2.376-.086a9.042,9.042,0,0,0-2.64,3.985c.35-.134.725-.261,1.127-.374,1.021-.024,2.341-.106,4.042-.292,0,0,6-.547,8.045-.394",
  transform: "translate(-0.312 -1.721)",
  fill: "#dfdfdf"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2819",
  "data-name": "Path 2819",
  d: "M15.593,9.139a.291.291,0,0,1-.174-.052.15.15,0,0,1-.072-.126V5.56a.151.151,0,0,1,.072-.126.291.291,0,0,1,.174-.051h1.58a4.912,4.912,0,0,1,.817.062,2.542,2.542,0,0,1,.66.2,1.1,1.1,0,0,1,.459.382,1.088,1.088,0,0,1,0,1.156,1.227,1.227,0,0,1-.455.4A2.455,2.455,0,0,1,18,7.815a3.882,3.882,0,0,1-.79.076h-.574c-.023,0-.035.008-.035.025V8.961a.153.153,0,0,1-.068.126.276.276,0,0,1-.171.052ZM16.6,7.157c0,.017.012.024.035.024h.512q.9,0,.9-.577a.4.4,0,0,0-.233-.392,1.636,1.636,0,0,0-.7-.115h-.479c-.023,0-.035.007-.035.019Z",
  transform: "translate(-2.412 -0.846)",
  fill: "#07df80"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2820",
  "data-name": "Path 2820",
  d: "M16.32,23a3.787,3.787,0,0,1-2.533-1,.505.505,0,0,1,.725-.7c.065.065,1.583,1.558,3.856-.058a.506.506,0,1,1,.586.824A4.51,4.51,0,0,1,16.32,23",
  transform: "translate(-2.144 -3.323)",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2821",
  "data-name": "Path 2821",
  d: "M12.981,20.594h-.425a.286.286,0,0,1-.287-.287V18.677a.287.287,0,0,1,.287-.287h.425a.287.287,0,0,1,.287.287v1.631a.286.286,0,0,1-.287.287",
  transform: "translate(-1.928 -2.89)",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2822",
  "data-name": "Path 2822",
  d: "M20.914,20.594H20.49a.286.286,0,0,1-.287-.287V18.677a.287.287,0,0,1,.287-.287h.425a.287.287,0,0,1,.287.287v1.631a.286.286,0,0,1-.287.287",
  transform: "translate(-3.175 -2.89)",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2823",
  "data-name": "Path 2823",
  d: "M25.577,9c0-2.775,1.5-6.042-6.782-7.461A20.953,20.953,0,0,0,4.914,3.664C2.153,5.085,3.448,8.919,3.448,8.919l10.624,1.306Z",
  transform: "translate(-0.494 -0.189)",
  fill: "#c5c5c5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2824",
  "data-name": "Path 2824",
  d: "M14.7,1.011a23.071,23.071,0,0,1,3.9.335c8.281,1.419,6.782,4.686,6.782,7.461L13.883,10.036,3.26,8.73S1.964,4.9,4.725,3.476A20.019,20.019,0,0,1,14.7,1.011M14.7,0A21.06,21.06,0,0,0,4.225,2.6C1.47,4.046,1.759,7.45,2.3,9.054a1.012,1.012,0,0,0,.835.68L13.76,11.04a1.2,1.2,0,0,0,.123.007c.036,0,.072,0,.108-.005L25.5,9.813a1.012,1.012,0,0,0,.9-1.006c0-.33.024-.678.05-1.047.177-2.542.419-6.024-7.673-7.411A24.21,24.21,0,0,0,14.7,0",
  transform: "translate(-0.306 0)",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2825",
  "data-name": "Path 2825",
  d: "M14.9,12.647a66.374,66.374,0,0,0-7.223.394,23.256,23.256,0,0,1-5.882.195,1.327,1.327,0,0,1-1.016-.8C-.7,8.975,7.536,9.808,7.536,9.808a57.792,57.792,0,0,0,13.115-.042s8.241-.834,6.76,2.632a1.329,1.329,0,0,1-1.016.8s-4.6.028-11.5-.547",
  transform: "translate(-0.094 -1.521)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2826",
  "data-name": "Path 2826",
  d: "M3.394,13.75a11.922,11.922,0,0,1-1.773-.11,1.822,1.822,0,0,1-1.405-1.1,1.934,1.934,0,0,1,.122-2.014C1.7,8.681,6.9,9.15,7.493,9.209A57.925,57.925,0,0,0,20.5,9.167c.6-.061,5.8-.528,7.163,1.319a1.935,1.935,0,0,1,.122,2.014,1.824,1.824,0,0,1-1.406,1.1c-.117,0-4.778.026-11.616-.543a65.539,65.539,0,0,0-7.13.393,35.872,35.872,0,0,1-4.237.3M5.5,10.124c-1.8,0-3.788.244-4.346,1-.12.163-.251.446-.007,1.017a.827.827,0,0,0,.627.5,22.79,22.79,0,0,0,5.745-.2,66.014,66.014,0,0,1,7.326-.4c6.79.566,11.406.548,11.453.544a.817.817,0,0,0,.555-.489c.244-.572.113-.855-.007-1.018-.77-1.047-4.235-1.116-6.238-.912a58.8,58.8,0,0,1-13.234.04c-.543-.054-1.2-.088-1.874-.088",
  transform: "translate(0 -1.425)",
  fill: "gray"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2827",
  "data-name": "Path 2827",
  d: "M15.073,8.524a.245.245,0,0,1-.146-.043.128.128,0,0,1-.06-.105V5.531a.129.129,0,0,1,.06-.105.245.245,0,0,1,.146-.043h1.322a4.2,4.2,0,0,1,.684.051,2.138,2.138,0,0,1,.552.167.928.928,0,0,1,.383.319.912.912,0,0,1,0,.967,1.023,1.023,0,0,1-.381.338,2.036,2.036,0,0,1-.546.192,3.261,3.261,0,0,1-.661.064h-.48c-.019,0-.029.007-.029.02v.874a.129.129,0,0,1-.057.105.232.232,0,0,1-.143.043Zm.841-1.657c0,.013.009.02.029.02h.429q.755,0,.755-.482a.338.338,0,0,0-.195-.328,1.385,1.385,0,0,0-.589-.1h-.4c-.019,0-.029.006-.029.017Z",
  transform: "translate(-2.336 -0.846)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2828",
  "data-name": "Path 2828",
  d: "M16.237,5.226a4.112,4.112,0,0,1,.684.051,2.148,2.148,0,0,1,.552.167.928.928,0,0,1,.383.319.91.91,0,0,1,0,.967,1.014,1.014,0,0,1-.38.338,2.065,2.065,0,0,1-.546.192,3.267,3.267,0,0,1-.661.064h-.48c-.019,0-.029.007-.029.02v.874a.129.129,0,0,1-.057.105.232.232,0,0,1-.143.043h-.641a.245.245,0,0,1-.146-.043.128.128,0,0,1-.06-.105V5.374a.129.129,0,0,1,.06-.105.245.245,0,0,1,.146-.043Zm-.452,1.5h.429q.755,0,.755-.482a.338.338,0,0,0-.195-.328,1.385,1.385,0,0,0-.589-.1h-.4c-.019,0-.029.006-.029.017v.87c0,.013.009.02.029.02m.452-2.347H14.915a1.085,1.085,0,0,0-.639.2.965.965,0,0,0-.41.789V8.219a.965.965,0,0,0,.41.789,1.085,1.085,0,0,0,.639.2h.641A1.069,1.069,0,0,0,16.208,9a.969.969,0,0,0,.392-.777V8.155a3.868,3.868,0,0,0,.5-.069,2.914,2.914,0,0,0,.77-.273,1.869,1.869,0,0,0,.685-.614,1.753,1.753,0,0,0,0-1.906,1.759,1.759,0,0,0-.725-.612,3,3,0,0,0-.77-.235,4.969,4.969,0,0,0-.823-.063",
  transform: "translate(-2.179 -0.689)",
  fill: "gray"
})))))))));

function SvgIconAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon-avatar.1bf1d813.svg";
export { ForwardRef as ReactComponent };